<template>
  <section class="tables">
    <vue-snotify></vue-snotify>
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Seminar Attendees</h4>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-lg-5 col-md-6">
                    <b-form-group label="" label-for="Status">
                      <b-form-select
                        class="mb-3"
                        v-model="moduleNum"
                        @change="rsvpAttendees"
                        :options="dropdown"
                        value-field="val"
                        text-field="text"
                        disabled-field="notEnabled"
                      >
                      </b-form-select>
                    </b-form-group>
                  </div>
                  <div class="col-lg-7 col-md-6 pt-1 form-group">
                    <button
                      class="btn m-1 btn-primary btn-sm"
                      @click="printAttendees"
                    >
                      <i class="fa fa-print"></i> Print Attendees
                    </button>
                    <button
                      class="btn m-1 btn-primary btn-sm"
                      @click="notAttendees"
                    >
                      <i class="fa fa-print"></i>
                      Print Not Attending
                    </button>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <p>
                  <span class="font-weight-bolder">Seminar Name:</span> Module
                  {{ moduleData[0].ModuleNumber }}
                  {{ moduleData[0].ModuleName }}
                </p>
                <p>
                  <span class="font-weight-bolder">Seminar Date:</span>
                  {{ ModuleStartDate(moduleData[0].ModuleStartDate) }}
                </p>
                <p>
                  <span class="font-weight-bolder">Seminar Location:</span>
                  {{ moduleData[0].ModuleAddress1 }}
                </p>
                <div style="width: 100%; overflow: auto">
                  <CircleLoader v-if="isLoading" />
                  <table class="table table-striped" style="width: 100%" v-else>
                    <thead class="text-white bg-primary">
                      <tr>
                        <th scope="col">Practices Names</th>
                        <th scope="col">Attendees</th>
                        <th scope="col">Not Attending</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-if="!noRecordFound">
                        <!-- {{ seminarData }} -->
                        <tr
                          v-for="(seminar, index) in seminarData"
                          :key="index"
                        >
                          <th scope="row">
                            {{
                              seminar[index] !== undefined &&
                              seminar[index].PracticeName !== null
                                ? seminar[index].PracticeName
                                : "Not Available"
                            }}
                          </th>

                          <td>
                            <div
                              class="checkbox-new radio-new text-attending"
                              v-for="(user, ind) in seminar"
                              :key="ind"
                            >
                              <template
                                v-if="
                                  user.isattending == null ||
                                  user.isattending == ''
                                "
                              >
                                <label
                                  class="float-left text-warning font_size_14"
                                  >{{ user.FirstName }} {{ user.LastName }} ({{
                                    user.Status
                                  }})</label
                                >
                              </template>
                            </div>
                          </td>
                          <td>
                            <div
                              class="checkbox-new radio-new text-attending"
                              v-for="(user, ind) in seminar"
                              :key="ind"
                            >
                              <template v-if="user.isattending == 2">
                                <label
                                  class="float-left text-danger font_size_14"
                                  >{{ user.FirstName }} {{ user.LastName }} ({{
                                    user.Status
                                  }})</label
                                >
                              </template>
                            </div>
                          </td>
                        </tr>
                      </template>
                      <template v-if="noRecordFound">
                        <tr>
                          <td colspan="3">
                            <h3 class="text-center">No Record Found</h3>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="printScr" class="bg-white d-none">
      <div class="row" id="Attendees">
        <div class="col-md-12">
          <h3 class="text-center">Seminar Attendees</h3>
          <p>
            <span class="font-weight-bolder">Seminar Name:</span> Module
            {{ moduleData[0].ModuleNumber }} {{ moduleData[0].ModuleName }}
          </p>
          <p>
            <span class="font-weight-bolder">Seminar Date:</span>
            {{ ModuleStartDate(moduleData[0].ModuleStartDate) }}
          </p>
          <p>
            <span class="font-weight-bolder">Seminar Location:</span>
            {{ moduleData[0].ModuleAddress1 }}
          </p>
          <table class="table table-striped">
            <thead class="text-white bg-primary">
              <tr>
                <th scope="col">Practices Names</th>
                <th scope="col">Attendees</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="!noRecordFound">
                <tr v-for="(seminar, index) in seminarData" :key="index">
                  <th scope="row">
                    {{
                      seminar[index] !== undefined &&
                      seminar[index].PracticeName !== null
                        ? seminar[index].PracticeName
                        : "Not Available"
                    }}
                  </th>
                  <td>
                    <div
                      class="checkbox-new radio-new text-attending"
                      v-for="(user, ind) in seminar"
                      :key="ind"
                    >
                      <template
                        v-if="
                          user.isattending == null || user.isattending == ''
                        "
                      >
                        <label class="float-left text-warning font_size_14"
                          >{{ user.FirstName }} {{ user.LastName }} ({{
                            user.Status
                          }})</label
                        >
                      </template>
                    </div>
                  </td>
                </tr>
              </template>
              <template v-if="noRecordFound">
                <tr>
                  <td colspan="3">
                    <h3 class="text-center">No Record Found</h3>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>

      <div class="row" id="notAttendees">
        <div class="col-md-12">
          <h3 class="text-center">Seminar Not Attending Practices</h3>
          <p>
            <span class="font-weight-bolder">Seminar Name:</span> Module
            {{ moduleData[0].ModuleNumber }} {{ moduleData[0].ModuleName }}
          </p>
          <p>
            <span class="font-weight-bolder">Seminar Date:</span>
            {{ ModuleStartDate(moduleData[0].ModuleStartDate) }}
          </p>
          <p>
            <span class="font-weight-bolder">Seminar Location:</span>
            {{ moduleData[0].ModuleAddress1 }}
          </p>
          <table class="table table-striped">
            <thead class="text-white bg-primary">
              <tr>
                <th scope="col">Practices Names</th>
                <th scope="col">Not Attending</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="!noRecordFound">
                <tr v-for="(seminar, index) in seminarData" :key="index">
                  <th scope="row">
                    {{
                      seminar[index] !== undefined &&
                      seminar[index].PracticeName !== null
                        ? seminar[index].PracticeName
                        : "Not Available"
                    }}
                  </th>

                  <td>
                    <div
                      class="checkbox-new radio-new text-attending"
                      v-for="(user, ind) in seminar"
                      :key="ind"
                    >
                      <template v-if="user.isattending == 2">
                        <label class="float-left text-danger font_size_14"
                          >{{ user.FirstName }} {{ user.LastName }} ({{
                            user.Status
                          }})</label
                        >
                      </template>
                    </div>
                  </td>
                </tr>
              </template>
              <template v-if="noRecordFound">
                <tr>
                  <td colspan="3">
                    <h3 class="text-center">No Record Found</h3>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from "vue";
import API from "@/api";
import moment from "moment";
import jsPDF from "jspdf";
import CircleLoader from "@/pages/loaders/CircleLoader.vue";
Vue.use(jsPDF);

export default {
  name: "attendess",
  data() {
    return {
      moduleNum: "",
      noRecordFound: true,

      dropdown: [
        {
          val: "",
          text: "Select seminar",
        },
      ],
      seminarData: [],
      moduleData: [
        {
          ModuleNumber: "",
          ModuleName: "",
          ModuleStartDate: "",
          ModuleAddress1: "",
          isLoading: false,
        },
      ],
    };
  },
  methods: {
    rsvpDropdown() {
      this.isLoading = true;
      API.rsvpDropdown((res) => {
        res.data.data.forEach((element) => {
          this.dropdown.push({
            text: `Module ${element.ModuleNumber} ${element.ModuleName}`,
            val: element.ModuleNumber,
          });
        });
        this.isLoading = false;
      });
    },
    // rsvpAttendees() {
    //   API.rsvpAttendees({ moduleNumber: this.moduleNum }, res => {
    //     this.moduleData = res.data.data;
    //     // console.log( this.moduleData[0].ModuleNumber);
    //     let Practice_id = [...new Set(res.data.data.map(ele => ele.Practice_id))];
    //     let arr = Object();
    //     Practice_id.forEach((prac, index) => {
    //       arr[index] = res.data.data.map(ele => {
    //         if (prac == ele.Practice_id) {
    //           return ele;
    //         }
    //       })
    //     })
    //     this.seminarData = arr;
    //     this.noRecordFound = false
    //   }, this.errorCB)
    // },
    rsvpAttendees() {
      API.rsvpAttendees(
        { moduleNumber: this.moduleNum },
        (res) => {
          this.moduleData = res.data.data;
          let Practice_id = [
            ...new Set(res.data.data.map((ele) => ele.Practice_id)),
          ];
          let arr = [];
          Practice_id.forEach((prac, index) => {
            arr.push(res.data.data.filter((ele) => ele.Practice_id === prac));
          });
          this.seminarData = arr;
          this.noRecordFound = false;
        },
        this.errorCB
      );
    },

    printAttendees() {
      let elementHTML = document.getElementById("Attendees");
      const doc = new jsPDF();
      doc.html(elementHTML, {
        callback: function (doc) {
          doc.save("Attendees.pdf");
        },
        margin: [10, 10, 10, 10],
        autoPaging: "text",
        x: 0,
        y: 0,
        width: 190,
        windowWidth: 675,
      });
    },
    notAttendees() {
      let elementHTML = document.getElementById("notAttendees");
      const doc = new jsPDF();
      doc.html(elementHTML, {
        callback: function (doc) {
          doc.save("Not Attending.pdf");
        },
        margin: [10, 10, 10, 10],
        autoPaging: "text",
        x: 0,
        y: 0,
        width: 190,
        windowWidth: 675,
      });
    },

    errorCB(err) {
      console.log(err);
      this.$showNotification({ message: "Failed system error" }, "error");
    },
  },

  mounted() {
    this.rsvpDropdown();
  },
  components: {},
  computed: {
    ModuleStartDate: function () {
      const self = this;
      return function (date) {
        if (date != "") {
          return moment(date).format("MMMM DD, yyyy");
        } else {
          return "";
        }
      }.bind(self);
    },
  },
};
</script>